export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Rating Votes',
        category: 'BGG',
        description: 'Number of community votes received for the game rating.',
        summarise: {
            prefix: 'Community rating'
        },
        unit: 'vote'
    },
    rules: {
        linked: [],
        legacy: ['threshold.community']
    }
}